/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Youtube_Url_LabelInputs */

const en_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube Page URL`)
};

const fr_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la page YouTube`)
};

const de_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube-Seiten-URL`)
};

const it_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL della pagina YouTube`)
};

const ru_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL страницы YouTube`)
};

const es_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la página de YouTube`)
};

const zh_cn2_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 页面网址`)
};

const ja_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeページのURL`)
};

const hi_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube पेज URL`)
};

const pt_pt2_new_project_youtube_url_label = /** @type {(inputs: New_Project_Youtube_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL da página do YouTube`)
};

/**
* | output |
* | --- |
* | "YouTube Page URL" |
*
* @param {New_Project_Youtube_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_youtube_url_label = /** @type {((inputs?: New_Project_Youtube_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Youtube_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_youtube_url_label(inputs)
	if (locale === "de") return de_new_project_youtube_url_label(inputs)
	if (locale === "it") return it_new_project_youtube_url_label(inputs)
	if (locale === "ru") return ru_new_project_youtube_url_label(inputs)
	if (locale === "es") return es_new_project_youtube_url_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_youtube_url_label(inputs)
	if (locale === "ja") return ja_new_project_youtube_url_label(inputs)
	if (locale === "hi") return hi_new_project_youtube_url_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_youtube_url_label(inputs)
	return en_new_project_youtube_url_label(inputs)
});